module.exports = __webpack_public_path__ + "static/media/undraw_Notify_re_65on.699ee064.png";